import React from "react";
import PageContainer from "@components/pages/PageContainer";
import HeaderCredits from "@components/composite/HeaderCredits/HeaderCredits";
import {PageWideScrollBox} from "@components/pages/page.layout";
import AccountDetails from "@as_core/account/AccountDetails";

const PgUserAccount = () => {

  return (
      <PageContainer title="User Account Information"  >
        <HeaderCredits />
        <PageWideScrollBox topMargin={160}>
          <AccountDetails />
        </PageWideScrollBox>
      </PageContainer>
  );
};
export default PgUserAccount;


